import Pusher from "pusher-js";

let client = null;
let currentToken = null;
let currentKey = null;
let currentCluster = null;
let currentAuthUrl = null;
const channelBindings = new Map();

const getConfig = () => {
  const authUrl =
    process.env.REACT_APP_PUSHER_AUTH_URL ||
    (process.env.REACT_APP_BACKEND_URL
      ? `${process.env.REACT_APP_BACKEND_URL}/broadcasting/auth`
      : null);

  return {
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER || "eu",
    authUrl,
  };
};

export const initPusher = ({ token } = {}) => {
  const { key, cluster, authUrl } = getConfig();
  if (!key) {
    return null;
  }

  const normalizedToken = token || "";
  if (
    client &&
    currentToken === normalizedToken &&
    currentKey === key &&
    currentCluster === cluster &&
    currentAuthUrl === authUrl
  ) {
    return client;
  }

  disconnectPusher();

  const options = {
    cluster,
    forceTLS: true,
  };

  if (authUrl) {
    options.authEndpoint = authUrl;
  }
  if (normalizedToken) {
    options.auth = {
      headers: {
        Authorization: `Bearer ${normalizedToken}`,
      },
    };
  }

  if (process.env.NODE_ENV !== "production") {
    Pusher.logToConsole = true;
  }

  client = new Pusher(key, options);
  currentToken = normalizedToken;
  currentKey = key;
  currentCluster = cluster;
  currentAuthUrl = authUrl;

  return client;
};

export const getPusher = () => client;

export const disconnectPusher = () => {
  if (!client) return;
  for (const channelName of channelBindings.keys()) {
    client.unsubscribe(channelName);
  }
  channelBindings.clear();
  client.disconnect();
  client = null;
};

const getChannel = (channelName) => {
  if (!client) return null;
  const existing = client.channel(channelName);
  if (existing) return existing;
  return client.subscribe(channelName);
};

export const bindEvent = (channelName, eventName, handler) => {
  if (!client) {
    initPusher({ token: localStorage.getItem("accessToken") || "" });
  }

  const channel = getChannel(channelName);
  if (!channel) return () => {};

  let events = channelBindings.get(channelName);
  if (!events) {
    events = new Map();
    channelBindings.set(channelName, events);
  }

  let handlers = events.get(eventName);
  if (!handlers) {
    handlers = new Set();
    events.set(eventName, handlers);
  }

  handlers.add(handler);
  channel.bind(eventName, handler);

  return () => unbindEvent(channelName, eventName, handler);
};

export const unbindEvent = (channelName, eventName, handler) => {
  const channel = client?.channel(channelName);
  if (channel) {
    channel.unbind(eventName, handler);
  }

  const events = channelBindings.get(channelName);
  if (!events) return;

  const handlers = events.get(eventName);
  if (handlers) {
    handlers.delete(handler);
    if (handlers.size === 0) {
      events.delete(eventName);
    }
  }

  if (events.size === 0) {
    channelBindings.delete(channelName);
    if (client) {
      client.unsubscribe(channelName);
    }
  }
};
